import type { IRange } from "app/pages/sales-intelligence/types/range";

import type { IFilterPanelBaseFilterDeps } from "../../types/filters";
import type { FilterValueDelta } from "../../types/misc";
import { calculateRangeDelta } from "../../utils/calculateValueDeltaUtils";
import { FilterPanelBaseFilter } from "../BaseFilter";

import type { IRangeSelectFilterOptions } from "./FilterOptions";

export default class FindRangeSelectFilter extends FilterPanelBaseFilter<
    Partial<IRange<number>>,
    IRangeSelectFilterOptions
> {
    constructor(deps: IFilterPanelBaseFilterDeps<Partial<IRange<number>>, IRangeSelectFilterOptions>) {
        super(deps);
    }

    calculateValueDelta = (
        previousValue: Partial<IRange<number>> | undefined,
        newValue: Partial<IRange<number>> | undefined,
    ): FilterValueDelta<Partial<IRange<number>>> => {
        return calculateRangeDelta(previousValue, newValue);
    };
}
